export default {"src":"/_next/static/media/avalanche.f6d57d19.svg","height":1504,"width":1503,"blurWidth":0,"blurHeight":0};